"use strict";

const TIPO_FILTRO_OPCOES = {
  HOJE: "Hoje",
  ESTASEMANA: "Esta semana",
  ESTEMES: "Este mês",
  ULTIMOS30DIAS: "Últimos trinta dias",
  PERSONALIZADO: "Personalizado",
  DIAANTERIOR: "Dia anterior",
};

const TIPO_FILTRO = [
  "Hoje",
  "Esta semana",
  "Este mês",
  "Últimos trinta dias",
  "Dia anterior",
  "Personalizado",
];

const TIPO_PERFIL_USUARIO = {
  ADMIN: 1,
  GERENTE: 2,
  SUPERVISOR: 3,
  ANALISTA: 4,
};

const CORES_GRAFICO = {
  AZUL: "#0077C2",
  AZUL_MAIS_CLARO: "#82b0db",
  AZUL_CLARO: "#009FAF",
  AMARELO: "#FFB74D",
  CINZA: "#8D8D8D",
  VERDE: "#66BB6A",
  VERMELHO: "#EF5350",
  VERDE_MUSGO: "#4F9A94",
  GOIABA: "#EF9A9A",
  ROXO_CLARO: "#AF8EB5",
  ROXO_ESCURO: "#65499C",
};

const CRIPTOGRAFIA_AES = {
  CHAVE : "123456673959499f9d37623168b2c977",
  VETOR_INICIALIZACAO : "14e75276277644f0"
};

export { TIPO_FILTRO_OPCOES, TIPO_FILTRO, TIPO_PERFIL_USUARIO, CORES_GRAFICO, CRIPTOGRAFIA_AES };
